import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { FileEdit } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/api-integrations/form-designer')({
    staticData: {
        metadata: {
            title: 'Form designer',
        },
        permissions: ['settings:update'],
        featureFlag: 'form-designer',
        ui: {
            icon: FileEdit,
            title: 'Form designer',
            useTitleForChildren: true,
            menuDescription: 'Build and manage dynamic forms',
        },
    },
    component: FormDesignerLayout,
});

function FormDesignerLayout() {
    return (
        <PageController route={Route}>
            <Outlet />
        </PageController>
    );
}
